
const phoneCountryCodes = [
    { code: '+86', label: '中国', short: 'CN' },
    { code: '+852', label: '香港', short: 'HK' },
    { code: '+853', label: '澳门', short: 'MO' },
    { code: '+886', label: '台湾', short: 'TW' },
    { code: '+1', label: '美国/加拿大', short: 'US' },
    { code: '+44', label: '英国', short: 'GB' },
    { code: '+81', label: '日本', short: 'JP' },
    { code: '+82', label: '韩国', short: 'KR' },
    { code: '+65', label: '新加坡', short: 'SG' },
    { code: '+60', label: '马来西亚', short: 'MY' },
    { code: '+61', label: '澳大利亚', short: 'AU' },
    { code: '+49', label: '德国', short: 'DE' },
    { code: '+33', label: '法国', short: 'FR' },
    { code: '+7', label: '俄罗斯', short: 'RU' },
    { code: '+91', label: '印度', short: 'IN' },
    { code: '+55', label: '巴西', short: 'BR' },
    { code: '+62', label: '印尼', short: 'ID' },
    { code: '+66', label: '泰国', short: 'TH' },
    { code: '+84', label: '越南', short: 'VN' },
    { code: '+63', label: '菲律宾', short: 'PH' },
    { code: '+971', label: '阿联酋', short: 'AE' },
    { code: '+34', label: '西班牙', short: 'ES' },
    { code: '+39', label: '意大利', short: 'IT' },
    { code: '+31', label: '荷兰', short: 'NL' },
    { code: '+46', label: '瑞典', short: 'SE' },
    { code: '+41', label: '瑞士', short: 'CH' },
    { code: '+48', label: '波兰', short: 'PL' },
    { code: '+90', label: '土耳其', short: 'TR' },
    { code: '+234', label: '尼日利亚', short: 'NG' },
    { code: '+27', label: '南非', short: 'ZA' },
    { code: '+20', label: '埃及', short: 'EG' },
    { code: '+52', label: '墨西哥', short: 'MX' },
    { code: '+54', label: '阿根廷', short: 'AR' },
    { code: '+64', label: '新西兰', short: 'NZ' },
    { code: '+353', label: '爱尔兰', short: 'IE' },
    { code: '+351', label: '葡萄牙', short: 'PT' },
    { code: '+380', label: '乌克兰', short: 'UA' },
    { code: '+47', label: '挪威', short: 'NO' },
    { code: '+45', label: '丹麦', short: 'DK' },
    { code: '+358', label: '芬兰', short: 'FI' },
];

export default phoneCountryCodes;
